var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7673 8.61371C11.962 6.44791 13.7831 4.75 16 4.75C18.3472 4.75 20.25 6.65279 20.25 9C20.25 11.3472 18.3472 13.25 16 13.25C15.488 13.25 14.9987 13.1598 14.5461 12.995C13.9175 12.7662 13.1115 12.8279 12.5486 13.3908L11.2626 14.6768C11.2157 14.7237 11.1521 14.75 11.0858 14.75H10C9.30964 14.75 8.75 15.3096 8.75 16V16.75H7.5C6.80964 16.75 6.25 17.3096 6.25 18V19C6.25 19.1381 6.13807 19.25 6 19.25H4C3.86193 19.25 3.75 19.1381 3.75 19V16.4538C3.75 16.3817 3.78112 16.3131 3.83537 16.2656L11.1524 9.86324C11.5404 9.52377 11.7275 9.05601 11.7673 8.61371ZM16 3.25C12.9997 3.25 10.5369 5.54734 10.2733 8.47942C10.2614 8.61153 10.2107 8.69408 10.1646 8.73438L2.84762 15.1368C2.46784 15.4691 2.25 15.9491 2.25 16.4538V19C2.25 19.9665 3.0335 20.75 4 20.75H6C6.9665 20.75 7.75 19.9665 7.75 19V18.25H9C9.69036 18.25 10.25 17.6904 10.25 17V16.25H11.0858C11.5499 16.25 11.995 16.0656 12.3232 15.7374L13.6092 14.4514C13.6738 14.3868 13.8277 14.3298 14.033 14.4045C14.6476 14.6283 15.3104 14.75 16 14.75C19.1756 14.75 21.75 12.1756 21.75 9C21.75 5.82436 19.1756 3.25 16 3.25ZM17 9C17.5523 9 18 8.55228 18 8C18 7.44772 17.5523 7 17 7C16.4477 7 16 7.44772 16 8C16 8.55228 16.4477 9 17 9Z",
    fill: "#272835"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyIcon);
export default __webpack_public_path__ + "static/media/key-icon.5ccaede5477674051845b3ca8f4ad6bd.svg";
export { ForwardRef as ReactComponent };